// Component
import Channel from './components/Channel';

// Firebase
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// React
import { useEffect, useState } from 'react';
import React from 'react';
import { Button, Modal, Tooltip } from 'flowbite-react';

const firebaseConfig = {
  apiKey: "AIzaSyCE3p2OQrmR_GHis-BVG-H9bP5H3txsS2U",
  authDomain: "komunitichat.firebaseapp.com",
  projectId: "komunitichat",
  storageBucket: "komunitichat.appspot.com",
  messagingSenderId: "67297223472",
  appId: "1:67297223472:web:b1fba07ca7ac607bf95ef5",
  measurementId: "G-DNJHG765GC"
};
initializeApp(firebaseConfig);
const auth = getAuth();

function App() {
  const [user, setUser] = useState(() => auth.currentUser);
  const [initializing, setInitializing] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalSignOut, SetModalSignOut] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
      if (initializing) {
        setInitializing(false);
      }
    });
    return unsubscribe
  })

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error(error);
    }
  }

  const signOut = async () => {
    try {
      await auth.signOut();
      toggleModalSignOut();
    } catch (error) {
      console.log(error.message);
    }
  };

  const toggleModal = () => {
    setModal(!modal);
  }
  const toggleModalSignOut = () => {
    SetModalSignOut(!modalSignOut);
  }


  if (initializing)
    return
  <div className='flex justify-center items-center h-screen w-screen'>
    <div className='flex flex-col place-items-center'>
      <h1 className='text-white text-center mb-5'>Initialize...</h1>
    </div>
  </div>;

  return (
    <div className='dark:bg-neutral-800'>
      {user ? (
        <div className='dark:bg-neutral-800 pb-1'>
          {/* Header */}
          <div className='flex justify-between items-center py-3 px-5 sticky top-0 shadow-xl2 bg-neutral-100 dark:bg-neutral-700'>
            <div className='flex items-center'>
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt="Avatar"
                  className="rounded-full w-12 h-12"
                />
              ) :
                <div className="relative w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
                  <svg className="absolute w-12 h-12 text-gray-400 -left-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
                </div>}
              <p className='text-gray-700 dark:text-gray-50 font-semibold ml-4'>{user.displayName}</p>
            </div>
            <div>
              <React.Fragment>
                <Button onClick={signOut}>
                  <p className='font-bold'>LogOut</p>
                </Button>
                <Modal
                  show={modalSignOut}
                  size="sm"
                  onClose={toggleModalSignOut}
                >
                  <Modal.Header />
                  <Modal.Body className="text-center">
                   
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                      Are you sure you want to Log out?
                    </h3>
                    <div className="flex justify-center gap-4">
                      <Button
                        color="red"
                        onClick={signOut}
                      >
                        Yes, I'm sure
                      </Button>
                      <Button
                        color="alternative"
                        onClick={toggleModalSignOut}
                      >
                        No, cancel
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </React.Fragment>
            </div>
          </div>
          <Channel />
        </div>
      ) : (
        <div className='flex justify-center items-center h-screen w-screen px-5'>
          <div className="flex flex-col items-center p-6 max-w-sm bg-neutral-50 rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <div className='flex items-center mb-2'>
              <h5 className="text-center text-2xl font-bold tracking-tight text-gray-900 dark:text-white pr-2">Welcome to KomunitiChat</h5>
              <Tooltip content="Technology stack info">
                <React.Fragment>
                  <svg onClick={toggleModal} className="w-6 h-6 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                  <Modal
                    show={modal}
                    onClose={toggleModal}
                  >
                    <Modal.Header>
                      Technology Stack &#38; Features
                    </Modal.Header>
                    <Modal.Body className="space-y-6">
                      <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                        Im creating this project as a part of building my portfolio. This project is a chat application that is built with ReactJS and Firebase. It is a realtime chat application that allows users to chat with each other.
                      </p>
                      <p className="text-gray-700 dark:text-gray-100 font-bold">Features</p>
                      <ul className="list-disc list-inside text-gray-700 dark:text-gray-100">
                        <li>Realtime chat</li>
                        <li>Display auto follow system setting (Dark Mode)</li>
                        <li>Google authentication</li>
                      </ul>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        color="alternative"
                        onClick={toggleModal}
                      >
                        OK
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </React.Fragment>
              </Tooltip>
            </div>
            <p className="mb-3 text-center font-normal text-gray-700 dark:text-gray-400">KomunitiChat app brings the community together. A single chat room where members can send messages for the whole group to see.</p>
            <div>
              <button onClick={signInWithGoogle} type="button" className="mt-5 text-white bg-[#4285F4] hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#4285F4]/55">
                <svg className="w-4 h-4 mr-2 -ml-1" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
                Sign in with Google
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default App;
